import cn from 'classnames'
import type {LinkProps} from 'next/link'
import NextLink from 'next/link'
import type {ReactNode} from 'react'
import {memo} from 'react'

export const Link = memo(function (
  props: {
    children: ReactNode
    className?: string
    isInverted?: boolean
    target?: string
  } & LinkProps,
) {
  return (
    <NextLink
      {...(Object.fromEntries(
        Object.entries(props).filter(([key]) => !['className', 'isInverted'].includes(key)),
      ) as LinkProps)}
      className={cn(
        'transition-colors',
        {'hover:text-72716e active:text-72716e': !props.isInverted},
        {'text-ffffff hover:text-9eaaa5 active:text-9eaaa5': props.isInverted},
        props.className,
      )}
    />
  )
})
